export const CONFIG_FETCH_REQUEST = "CONFIG_FETCH_REQUEST";
export const CONFIG_FETCH_SUCCESS = "CONFIG_FETCH_SUCCESS";
export const CONFIG_FETCH_FAILURE = "CONFIG_FETCH_FAILURE";
export const CONFIG_CLEAR_CACHE = "CONFIG_CLEAR_CACHE";
